import { render, staticRenderFns } from "./habitDrinkForm.vue?vue&type=template&id=83f4644a&scoped=true"
import script from "./habitDrinkForm.vue?vue&type=script&lang=js"
export * from "./habitDrinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f4644a",
  null
  
)

export default component.exports